/**
 * Version of the tool list the tinycms MCP server offers to AI assistants.
 *
 * Mirrors MCP_TOOLS_VERSION in smagent-apiserver src/mcp/createServer.js and
 * must be bumped together with it. Cross-repo coupling until the API exposes
 * the version and the app can read it instead of hard-coding it.
 */
export const MCP_TOOLS_VERSION = '1.2.0';
